export default __webpack_public_path__ + "static/media/flatware_light.162433a7.png";